import { render, staticRenderFns } from "./AssociatedResponsibilitiesModal.vue?vue&type=template&id=0bd5caa0&scoped=true&"
import script from "./AssociatedResponsibilitiesModal.vue?vue&type=script&lang=js&"
export * from "./AssociatedResponsibilitiesModal.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/pages/administrator/functions.scss?vue&type=style&index=0&id=0bd5caa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5caa0",
  null
  
)

export default component.exports